import { Link } from 'react-router';

import { Icon } from '../../components/Icon/Icon';
import { setConsent, useConsentPending } from './consent';
import styles from './CookieConsentBanner.module.css';

/**
 * Aviso de cookies de analítica, abajo y a una mano como el control de la melodía. Hasta que se
 * acepte, Google Analytics no carga; "Rechazar" lo deja apagado en este dispositivo.
 */
export function CookieConsentBanner() {
  const pending = useConsentPending();
  if (!pending) return null;

  return (
    <section className={styles.banner} aria-label="Aviso de cookies">
      <div className={styles.head}>
        <span className={styles.badge} aria-hidden="true">
          <Icon name="grano" size={20} />
        </span>
        <p className={styles.text}>
          <b>¿Nos dejas usar cookies de analítica?</b>
          <br />
          Nos ayudan a saber cómo se recorre el Parche. Más en <Link to="/privacidad">Privacidad</Link>.
        </p>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.reject} onClick={() => setConsent('denied')}>
          Rechazar
        </button>
        <button type="button" className={styles.accept} onClick={() => setConsent('granted')}>
          <Icon name="check" size={18} />
          Aceptar
        </button>
      </div>
    </section>
  );
}
